import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getParticipants, deleteParticipant } from '../../../../api/participant'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import { getGroups } from '../../../../api/group'
import { getGames } from '../../../../api/game'

function getData(participants, groups, games) {
  let data = []
  for (let i = 0; i < participants.length; ++i) {
      const elem = {}
      elem.name = participants[i].fullName
  		elem.group = participants[i].group
  			? groups.find((cat) => cat._id === participants[i].group)?.fullName
  			: '---';
      let gameid = participants[i].group
  			? groups.find((cat) => cat._id === participants[i].group)?.game
  			: '---';
      elem.game = gameid
  			? games.find((cat) => cat._id === gameid)?.fullName
  			: '---';
      elem.createdAt = participants[i].createdAt
      elem.id = participants[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function ParticipantsPage() {
  const [data, setData] = useState([])
  const [participantId, setParticipantId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  const buildExportFilename = () => {
    const now = new Date()
    const yyyy = now.getFullYear()
    const mm = String(now.getMonth() + 1).padStart(2, '0')
    const dd = String(now.getDate()).padStart(2, '0')
    const hh = String(now.getHours()).padStart(2, '0')
    const mi = String(now.getMinutes()).padStart(2, '0')
    return `participants_${yyyy}${mm}${dd}_${hh}${mi}.csv`
  }

  const csvEscape = (value) => {
    const str = value == null ? '' : String(value)
    if (/[",;\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`
    return str
  }

  const exportParticipantsExcel = () => {
    if (!data?.length) {
      alertError({ customMessage: 'No participants available to export.' })
      return
    }

    const rows = [...data].sort((a, b) => {
      const groupA = (a.group || '').toLowerCase()
      const groupB = (b.group || '').toLowerCase()
      if (groupA !== groupB) return groupA.localeCompare(groupB)
      return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
    })

    const header = ['Full name', 'Group', 'Game', 'Created at']
    const body = rows.map((row) => [
      row.name || '',
      row.group || '',
      row.game || '',
      row.createdAt ? new Date(row.createdAt).toISOString() : '',
    ])

    const csv = [header, ...body]
      .map((line) => line.map(csvEscape).join(';'))
      .join('\n')

    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', buildExportFilename())
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-participant/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setParticipantId(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }


  const columns = [
    { dataField: 'name', text: 'Full name', sort: true },
    { dataField: 'group', text: 'Group', sort: true },
    { dataField: 'game', text: 'Game', sort: true },
    { dataField: 'createdAt', text: 'Created at', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getParticipants().then((res) => {
      if (res.status === 200) {
        getGroups().then((respGroups) => {
          if (respGroups.status === 200) {
            getGames().then((respGames) => {
              if (respGames.status === 200) {
                setData(getData(res.data, respGroups.data, respGames.data))
                setRefresh(false)
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'Could not get games.' })
            })
          }
        }).catch(error => {
          alertError({ error: error, customMessage: 'Could not get groups.' })
        })
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get participants.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Participants list'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-light-primary mr-2"
                onClick={exportParticipantsExcel}
              >
                Export Excel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/edit-participant')}
              >
                Add new
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={'Are you sure you want to remove this participant?'}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteParticipant(participantId).then(res => {
                if (res.status === 204) {
                  alertSuccess({  title: 'Deleted!', customMessage: 'Participant removed successfully.' })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: 'Could not remove participant.' })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
